import { defineComponent as _defineComponent } from 'vue'
import MiniCard from "@/components/molecules/card/MiniCard.vue";
import { DashboardSectionCard } from "./types";

export interface DashboardSectionProps {
    title: string;
    cards: DashboardSectionCard[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSection',
  props: {
    title: null,
    cards: null
  },
  setup(__props: any) {



return { __sfc: true,MiniCard }
}

})